import React from "react"

export const Context = React.createContext({
  userInfo: {} as API.UserInfo,
  airdropState: 1, // 1: no airdrop, 2: need to claim, 3: claimed
  setUserInfo: (info: API.UserInfo) => {},
  updateAirdropState: (state: number) => {},
})